<template>
  <div class="home">
    <Hero title="Aqui, sua <span>carreira</span><br />acontece" image="banner-home.png" layout="md" :search="true" />

    <JunteSeANos />

    <OurStore />

    <Areas />

    <Collaborators />

    <Cards />

    <Benefits />

    <Stamps />

    <div class="cadastro">
      <div class="c-tittle">
        <h2>Venha trabalhar <strong>com a gente</strong></h2>
      </div>
      <div class="c-button">
        <router-link to="/deixe-seu-perfil" class="btn btn-color-1 rounded-xl text-color-2 px-4 mr-3">Quero me
          inscrever</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import Share from "@/components/jobs/Share.vue";
import OurStore from "./home/OurStores.vue"
import JunteSeANos from "@/views/home/JunteSeANos.vue";
import Areas from "@/views/home/Areas.vue";
import Collaborators from "@/views/home/Collaborators.vue";
import Cards from "@/views/home/Cards.vue";
import Benefits from "@/views/home/Benefits.vue";
import Stamps from "@/views/home/Stamps.vue";

export default {
  name: "home",

  data() {
    return {
      search: "",
    };
  },

  components: {
    Share,
    Hero,
    OurStore,
    JunteSeANos,
    Areas,
    Collaborators,
    Cards,
    Benefits,
    Stamps,
  },

  mounted() {
  },

  computed: {
  },

  methods: {


    sendToLogin() {
      this.$store.commit("user/SET_NEXT_ROUTE", { path: "/vagas" });
      this.$store.commit("DEVISE_FORM", "login");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .hero {
  .text {
    min-width: 60%;
    align-self: flex-start;
    margin-left: 55px;

    @include media-breakpoint-down(md) {
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

.cadastro {
  padding: 0 70px;
  margin-right: -15px;
  margin-left: -15px;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 1100px) {
    padding: 0;
  }

  .c-tittle {
    margin-top: 50px;
    display: flex;
    color: #0A1D6F;
    justify-content: center;

    h2 {
      font-weight: 400;
    }

    strong {
      color: #00CFD9;
      font-weight: bold;

    }

    @include media-breakpoint-down(md) {
      h2 {
        text-align: center;
      }
    }
  }

  .c-button {
    text-align: center;
    margin-bottom: 80px;
    margin-top: 10px;

    button {
      background-color: theme-color('color-1');
      padding: 6px 30px;
      color: #00CFD9;
      border-radius: 30px;

      &:hover {
        color: #0A1D6F !important;
        background: #00CFD9;
      }
    }
  }

  @include media-breakpoint-down(sm) {
    h1 {
      font-size: 25px;
    }
  }
}
</style>